import styled from "styled-components";

export const Label = styled.label`
color: ${props=>(props.color?props.color:"#606060")};
font-size: 19.5px;
font-weight: 499;
display: ${props=>(props.display?props.display:"")};
margin: ${(props) => (props.margin ? props.margin : "")};
float:${(props) => (props.float ? props.float : "")};
`

export const LoginLabel = styled.label`
color: ${props=>(props.color?props.color:"#606060")};
font-size: 18px;
font-weight: 500;
display: ${props=>(props.display?props.display:"")};
margin: ${(props) => (props.margin ? props.margin : "")};
padding: ${(props) => (props.padding ? props.padding : "")};
float:${(props) => (props.float ? props.float : "")};
`